import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import EditInventoryLocation from "../components/EditInventoryLocation";
import LocationOrders from "../components/LocationOrders";

type DetailSegment = "details" | "orders";

// Reads locationId ONCE from route state (set by ChannelPartnerList's
// navigateTo) and passes it down as a prop to both segments, rather than
// each child independently re-reading route state.
const ChannelPartnerDetail: React.FC = () => {
  const routeLocation = useLocation();
  const locationId: string | undefined = (routeLocation.state as any)?.locationId;
  const [segment, setSegment] = useState<DetailSegment>("details");

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Channel Partner</IonTitle>
        </IonToolbar>
        <IonSegment value={segment} onIonChange={(e) => setSegment((e.detail.value as DetailSegment) ?? "details")}>
          <IonSegmentButton value="details">
            <IonLabel>Details</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="orders">
            <IonLabel>Orders</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </IonHeader>
      <IonContent fullscreen>
        {!locationId ? (
          <IonItem lines="none">
            <IonLabel class="secondary-text">No channel partner selected.</IonLabel>
          </IonItem>
        ) : segment === "details" ? (
          <EditInventoryLocation locationId={locationId} />
        ) : (
          <LocationOrders locationId={locationId} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default ChannelPartnerDetail;
